<!--中转页面 -->
<template>
    <div>
        <img src="../../public/images/article/activity.jpg" style="width: 100%;">
        <img src="../../public/images/article/btn.jpg" style="width: 100%;" @click="init">
    </div>
</template>
<script >
export default {
    props: ['initData'],
    components: {},
    data() {
        return {
        }
    },
    watch: {
        initData: {
            deep: true,
            handler(val) {
                this.init()
            },
        },
    },
    created() {
    },
    mounted() {
        this.init()
    },
    methods: {
        // init() {
        //     let arr = []
        //     let m = 0
        //     setInterval(() => {
        //         m++
        //         if (m <= 80) {
        //             this.$fetch.api_article
        //                 .openApp().then((res) => {
        //                     if (res.code == 0) {
        //                         arr.push(res.data.split("=")[1])
        //                     }
        //                 })
        //         } else {
        //             console.log('arr', arr)
        //         }
        //     }, 1000)
        // }
        init() {
            let code = this.$route.params.id
            location.href = 'weixin://dl/business/?t=' + code
        }
    }
};
</script>
<style lang='scss'></style>